<template>
  <modal
    name="modal--product-counting-info"
    transition="nice-modal-fade"
    :click-to-close="true"
    :width="400"
    :height="'auto'"
    :adaptive="true"
    :reset="true"
    :scrollable="true"
    draggable=".drag-handler"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    class="py-10"
  >
    <div
      class="py-4 px-4 flex flex-col text-gray-900 h-full bg-white overflow-hidden w-full justify-between"
    >
      <div
        class="text-center text-4xl font-extralight tracking-tight leading-none drag-handler"
      >
        {{ product ? product.name : '' }}
      </div>
      <label
        class="mt-2 block text-center uppercase tracking-wide text-gray-700 text-sm font-bold"
        for="response"
      >
        Counting Instructions
      </label>
      <div
        class="mt-3 text-justify text-gray-700 text-2xl mb-3 font-extralight leading-tight"
      >
        {{
          product && product.instructions
            ? product.instructions
            : 'There are no counting instructions for this product.'
        }}
      </div>
      <div class="mt-4 flex flex-row justify-end">
        <button
          class="buttonOutline focus:shadow-outline focus:outline-none"
          type="button"
          @click="hideModal"
        >
          Close
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ModalProductCountingInfo',
  data() {
    return {
      id: null
    }
  },
  computed: {
    ...mapGetters('storeModule/vendors', ['vendors']),
    ...mapGetters('storeModule/products', ['productById']),
    product() {
      return this.id ? this.productById(this.id) : null
    }
  },
  methods: {
    ...mapActions('config', ['setFabVisible']),
    hideModal() {
      this.$modal.hide('modal--product-counting-info')
    },
    beforeOpen: function(event) {
      this.id = event && event.params ? event.params : null
      // if (!this.product.instructions) event.stop()
      this.setFabVisible(false)
    },
    beforeClose: function() {
      this.setFabVisible(true)
    }
  }
}
</script>
